import React, { Component } from "react";
import Logger from "../../utils/logger";
import { getPureMessage, IntlText } from "../util/Text";

export default class Textarea extends Component {
  onFocus = (event) => {
    if (this.props.ga != null) {
      Logger.event(this.props.ga);
    } else if (this.props.meta) {
      Logger.event({
        category: this.props.meta.form,
        action: "textarea",
        label: this.props.input.name,
      });
    }

    this.props.input.onFocus && this.props.input.onFocus(event);
  };

  render = () => {
    const hasError =
      this.props.meta && this.props.meta.touched && this.props.meta.error;
    const label = this.props.labelId
      ? getPureMessage(this.props.labelId)
      : this.props.label;
    const placeholder = this.props.placeholder ? this.props.placeholder : label;
    return (
      <div>
        {(() => {
          if (label != null) {
            return (
              <label className="uk-form-label uk-text-nowrap">
                {label}
                <wbr />
                {(() => {
                  if (this.props.required) {
                    return (
                      <small className="uk-text-danger">
                        {" "}
                        ※<IntlText id="forms.attr.required" />
                      </small>
                    );
                  }
                })()}
              </label>
            );
          }
        })()}
        {this.props.sample && (
          <span>
            <a className=" uk-margin-ssmall-left">
              <small>
                <IntlText id="forms.input.sample" />
              </small>
            </a>
            <div data-uk-drop="mode: click" className="uk-width-xlarge">
              <div className="uk-card uk-card-body uk-card-default uk-card-small">
                {this.props.sample}
              </div>
            </div>
          </span>
        )}
        <div className="uk-form-controls">
          <textarea
            className={
              "uk-textarea uk-height-medium uk-input-custom " +
              (hasError ? "uk-input-error" : null) +
              " " +
              this.props.className
            }
            {...this.props.input}
            placeholder={placeholder}
            autoCorrect="off"
            autoCapitalize="off"
            style={this.props.style}
            onFocus={this.onFocus}
          ></textarea>
        </div>
        <div className="uk-text-danger " style={{ minHeight: "18px" }}>
          <small>{hasError && this.props.meta.error}</small>
        </div>
      </div>
    );
  };
}
